var formatTime;

import {
  hexToRgb
} from 'helpers/colors';

import colors from 'constants/colors';

formatTime = function(date) {
  return moment(date).format('H:mm');
};

angular.module('gym.calendar').controller('MoveAttendeesSelectEventCtrl', ["$stateParams", "loadingAnimation", "$scope", "$modalInstance", "$http", "$filter", "$timeout", "ContrastColor", "gym", "eventScheduleId", "selectedBookingIds", "cancelScope", "exfEventId", "previousValues", function($stateParams, loadingAnimation, $scope, $modalInstance, $http, $filter, $timeout, ContrastColor, gym, eventScheduleId, selectedBookingIds, cancelScope, exfEventId, previousValues) {
  var defaultView, setDefaultDate;
  $scope.gym = gym;
  $scope.eventScheduleId = eventScheduleId;
  $scope.selectedBookingIds = selectedBookingIds;
  $scope.cancelScope = cancelScope;
  $scope.exfEventId = exfEventId;
  $scope.hideFullEvents = previousValues ? previousValues.hideFullEvents : true;
  $scope.increaseLimit = previousValues ? previousValues.increaseLimit : true;
  $scope.membershipHandling = previousValues ? previousValues.membershipHandling : 'not_free';
  $scope.membershipHandlingOptions = [
    {
      value: 'not_free',
      label: 'Transfer used membership allowance to new booking'
    },
    {
      value: 'free_class',
      label: 'New booking should be a free class'
    }
  ];
  defaultView = 'month';
  $scope.toggleIncreaseLimit = function(event) {
    if (event != null) {
      if (typeof event.stopPropagation === "function") {
        event.stopPropagation();
      }
    }
    return $scope.increaseLimit = !$scope.increaseLimit;
  };
  $scope.onHideFullEventsChange = function() {
    return $timeout(function() {
      return angular.element('#calendar').fullCalendar('refetchEvents');
    }, 0);
  };
  $scope.eventSources = [
    {
      events: function(start,
    end,
    callback) {
        var endDate,
    params,
    startDate;
        setDefaultDate(start);
        startDate = moment(start).subtract(1,
    'days').format('X');
        endDate = moment(end).add(1,
    'days').format('X');
        params = {
          start: startDate,
          end: endDate,
          '_': new Date().getTime()
        };
        if ($scope.exfEventId) {
          params.exf_event_id = $scope.exfEventId;
        }
        return $http.get(`gyms/${gym.id}/calendar/data`,
    {
          params: params
        }).then(function(response) {
          var events;
          events = response.data.filter(function(item) {
            var availablePlaces;
            if (item.id === eventScheduleId || item.cancelled) {
              return false;
            }
            if ($scope.hideFullEvents) {
              availablePlaces = (item.participant_limit || 0) - (item.bookings_count || 0);
              if (availablePlaces < $scope.selectedBookingIds.length) {
                return false;
              }
            }
            return true;
          }).map(function(item) {
            item.title = $filter('limitString')(item.title,
    50);
            item.color = item.color || colors.primary;
            item.textColor = ContrastColor.get(item.color,
    {
              darkColor: '#303030'
            });
            return item;
          });
          return callback(events);
        });
      }
    }
  ];
  $scope.uiConfig = {
    calendar: {
      header: null,
      editable: false,
      allDayDefault: false,
      allDaySlot: false,
      lazyFetching: false,
      defaultView: defaultView,
      firstDay: gym.gym_booking_detail.calendar_start_wday,
      firstHour: 9,
      eventAfterAllRender: function(view) {
        return $scope.calendarView = view;
      },
      eventClick: function(event) {
        var result;
        result = {
          event: event,
          hideFullEvents: $scope.hideFullEvents,
          increaseLimit: $scope.increaseLimit,
          membershipHandling: $scope.membershipHandling,
          selectedBookingIds: $scope.selectedBookingIds
        };
        return $modalInstance.close(result);
      },
      dayClick: function(date, allDay, event, sourceView) {
        var calendar;
        calendar = angular.element('#calendar');
        calendar.fullCalendar('changeView', 'agendaDay');
        return calendar.fullCalendar('gotoDate', date);
      },
      eventRender: function(event, element, view) {
        var availablePlaces, bgColor, label, ref, rgb, time;
        rgb = hexToRgb(event.color) || hexToRgb(colors.primary);
        bgColor = `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
        element.css('border', {
          'min-height': '29px'
        });
        element.find('.fc-event-inner').css({
          'background-color': bgColor
        });
        time = `${formatTime(event.start)} - ${formatTime(event.end)}`;
        element.find('.fc-event-time').text(time);
        if (!element.find('.fc-event-title').length) {
          element.find('.fc-event-inner').append(`<div class='fc-event-title'>${event.title}</div>`);
        }
        availablePlaces = (event.participant_limit || 0) - (event.bookings_count || 0);
        if (availablePlaces <= 0) {
          label = (ref = event.participant_limit) === 0 || ref === (void 0) || ref === null ? '0 PLACES' : 'FULL';
          element.find('.fc-event-inner').append(`<span class='fc-event__full'>${label}</span>`);
          element.addClass('fc-event--full');
        }
        if (moment(event.end).diff(event.start, 'hours') < 1 && view.name !== 'month') {
          return element.find('.fc-event-time').remove();
        }
      },
      loading: function(isLoading) {
        if (isLoading) {
          return loadingAnimation.show();
        } else {
          return loadingAnimation.hide();
        }
      }
    }
  };
  $scope.currentView = function() {
    var ref;
    return (ref = $scope.calendarView) != null ? ref.calendar.getView() : void 0;
  };
  $scope.currentViewName = function() {
    var ref;
    return ((ref = $scope.currentView()) != null ? ref.name : void 0) || defaultView;
  };
  setDefaultDate = function(date) {
    var calendarView, momentDate, ref;
    calendarView = ((ref = $scope.currentView()) != null ? ref.name : void 0) || defaultView;
    $scope.calendarViewName = (function() {
      switch (calendarView) {
        case 'month':
          return 'month';
        case 'agendaWeek':
          return 'week';
        case 'agendaDay':
          return 'day';
        case 'basicDay':
          return 'day';
      }
    })();
    return $scope.startDate = momentDate = calendarView === 'month' ? moment(date).add(2, 'w') : moment(date);
  };
  $scope.toDate = function(date) {
    return $scope.calendarView.calendar.gotoDate(date.toDate());
  };
  $scope.getTitle = function() {
    var ref, title;
    title = (ref = $scope.calendarView) != null ? ref.title : void 0;
    if (title) {
      return title.replace('&#8212;', '—');
    }
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss();
  };
}]);
